module.exports = __webpack_public_path__ + "static/media/alert.020a5b09.svg";